module.exports = __webpack_public_path__ + "img/sign1.b03c39a7.png";